import { Intent } from "@focus/focusUI";
import type { UploadFile } from "./useUploadQueue";

export const uploadStatusLabel: Record<UploadFile["status"], string> = {
  DONE: "Done",
  ERROR: "Error",
  STAGED: "Staged",
  UPLOADING: "Uploading",
};

export const uploadStatusClassName: Record<UploadFile["status"], string> = {
  DONE: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  ERROR: "bg-red-50 text-red-700 ring-red-200",
  STAGED: "bg-slate-100 text-slate-600 ring-slate-200",
  UPLOADING: "bg-sky-50 text-sky-700 ring-sky-200",
};

export const getUploadIntent = (status: UploadFile["status"]) => {
  switch (status) {
    case "UPLOADING":
      return Intent.PRIMARY;
    case "DONE":
      return Intent.SUCCESS;
    case "ERROR":
      return Intent.DANGER;
    default:
      return Intent.NONE;
  }
};

export const getStagedFileCount = (files: UploadFile[]) =>
  files.filter((file) => file.status === "STAGED").length;

